<template>
  <v-card class="candidate to do list">
    <v-card-title class="pt-4" :class="themes.candidate.light.dialogTitle">
      <div>
        <div class="title">
          My to do list
        </div>
        <div class="subheading" :class="themes.candidate.light.cardSubtitle">
          Steps to complete your profile and applications
        </div>
      </div>
      <v-spacer />
      <v-tooltip left>
        <v-btn slot="activator" :color="themes.candidate.light.primaryActionButton" @click="refresh" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <span>Refresh to do list</span>
      </v-tooltip>
    </v-card-title>

    <v-progress-linear indeterminate v-if="actionsLoading" :height="5" :color="themes.candidate.light.loading"
      class="ma-0" />

    <v-card-text v-if="actions.length" class="mt-2">
      <v-card tile flat v-for="(group, key) in groupedActions" :key="`action-group-${key}`" class="pb-2">
        <v-layout align-center justify-start row>
          <v-avatar size="40" class="ml-3 mt-1 mb-0" v-if="group[0] && group[0].opportunityApplication">
            <img :src="group[0].opportunityApplication.opportunity.logo ||
              '/img/missing/avatars/original.png'
              " :class="themes.client.light.muted" />
          </v-avatar>
          <v-subheader>{{ key }}</v-subheader>
        </v-layout>
        <article v-for="action in group" :key="`action-item-${action.id}`" :is="action.type.split('::')[1]"
          :action="action" @refresh="refresh" class="mb-4" />
      </v-card>
    </v-card-text>

    <v-list v-else-if="!actionsLoading">
      <v-list-tile>
        <v-list-tile-avatar>
          <v-icon>mdi-checkbox-marked-outline</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title :class="themes.candidate.light.mutedText">
            Nice, you are all caught up!
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-list v-else>
      <v-list-tile>
        <v-list-tile-avatar>
          <v-icon class="rotating">mdi-loading</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title :class="themes.candidate.light.mutedText">
            Loading...
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
// Components
import Assessment from '@/components/candidate/action_items/Assessment'
import Avatar from '@/components/candidate/action_items/Avatar'
import Biography from '@/components/candidate/action_items/Biography'
import Disability from '@/components/candidate/action_items/Disability'
import EmailConfirmation from '@/components/candidate/action_items/EmailConfirmation'
import Ethnicity from '@/components/candidate/action_items/Ethnicity'
import Experience from '@/components/candidate/action_items/Experience'
import Financial from '@/components/candidate/action_items/Financial'
import Flag from '@/components/candidate/action_items/Flag'
import Gender from '@/components/candidate/action_items/Gender'
import IdentityDocument from '@/components/candidate/action_items/IdentityDocument'
import Location from '@/components/candidate/action_items/Location'
import Mobile from '@/components/candidate/action_items/Mobile'
import ProfileQualification from '@/components/candidate/action_items/ProfileQualification'
import Registration from '@/components/candidate/action_items/Registration'
import Submission from '@/components/candidate/action_items/Submission'
import Transcript from '@/components/candidate/action_items/Transcript'
import SecondaryTranscript from '@/components/candidate/action_items/SecondaryTranscript'

// Helpers
import { mapGetters } from 'vuex'
import _ from 'lodash'

// Vue Component
export default {
  components: {
    Assessment,
    Avatar,
    Biography,
    Disability,
    EmailConfirmation,
    Ethnicity,
    Experience,
    Financial,
    Flag,
    Gender,
    IdentityDocument,
    Location,
    Mobile,
    ProfileQualification,
    Registration,
    SecondaryTranscript,
    Submission,
    Transcript,
  },
  created() {
    this.refresh()
  },
  computed: {
    ...mapGetters({
      actions: 'candidate/actionItems/all',
      actionsLoading: 'candidate/actionItems/loading',
    }),

    sortedActions() {
      if (!this.actions[0]) return []

      const actions = JSON.parse(JSON.stringify(this.actions))
      return actions.sort((a, b) => {
        if (!_.get(a, 'opportunityApplication') && _.get(b, 'opportunityApplication')) return -1
        if (_.get(a, 'opportunityApplication') && !_.get(b, 'opportunityApplication')) return 1
        return 0
      })
    },

    groupedActions() {
      if (!this.actions[0]) return []

      let grouped = {}
      this.sortedActions.forEach(a => {
        let group = _.get(a, 'opportunityApplication.opportunity.name') || 'General'
        if (!grouped[group]) {
          grouped[group] = []
        }

        grouped[group].push(a)
      })

      return grouped
    },
  },

  methods: {
    refresh() {
      this.$store.dispatch('candidate/actionItems/fetchAll')
    },
  },
}
</script>

<style>
@-webkit-keyframes rotating

/* Safari and Chrome */
  {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.rotating {
  -webkit-animation: rotating 1s linear infinite;
  -moz-animation: rotating 1s linear infinite;
  -ms-animation: rotating 1s linear infinite;
  -o-animation: rotating 1s linear infinite;
  animation: rotating 1s linear infinite;
}
</style>
